import { motion } from 'motion/react'
import styled from 'styled-components'
import { match, P } from 'ts-pattern'

import { CircularLoader, InfoIcon } from '@blade/ui-kit'

import { CheckCircleIcon, CrossCircleIcon, WarningTriangleIcon } from '../icons'

import type { SnackbarIntent } from './snackbar'
import type { IconProps } from '@blade/ui-kit'
import type { ClassNameProps } from '@root/shared/react'

export type SnackbarIconProps = {
  intent: SnackbarIntent
  icon: SnackbarIntent | React.FC<IconProps> | 'circular-loading'
} & ClassNameProps

export const SnackbarIcon: React.FC<SnackbarIconProps> = ({
  className,
  intent,
  icon,
}) => {
  const iconElement = match(icon)
    .with('warning', () => (
      <WarningTriangleIcon color="var(--warning-9)" size={12.5} />
    ))
    .with('success', () => (
      <CheckCircleIcon color="var(--success-9)" size={14} />
    ))
    .with('error', () => <CrossCircleIcon color="var(--error-9)" size={14} />)
    .with('info', () => <InfoIcon size={14} />)
    .with('circular-loading', () => <CircularLoader size={14} />)
    .with(P.shape({}), (Icon) => <Icon size={14} />)
    .exhaustive()

  return (
    <Root
      data-intent={intent}
      className={className}
      transition={{ duration: 0.15 }}
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
    >
      {iconElement}
    </Root>
  )
}

const Root = styled(motion.div)`
  width: 25px;
  height: 25px;
  background: var(--backgroundA-3);
  border-radius: 50%;

  display: grid;
  place-items: center;

  &[data-intent='info'] {
    background: var(--backgroundA-4);
  }
  &[data-intent='warning'] {
    background: var(--warningA-3);
  }
  &[data-intent='success'] {
    background: var(--successA-3);
  }
  &[data-intent='error'] {
    background: var(--errorA-3);
  }
`
